import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/api/config/general.service';
import { GroupService } from 'src/app/api/departure/group.service';
import { GlobalService } from 'src/app/api/global.service';
import { constants } from 'src/app/constants';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import { ToolsService } from 'src/app/utils/tools.service';
import AlertifyHelper from 'src/app/utils/utils';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'app-group-report-balance',
  templateUrl: './group-report-balance.component.html',
  styleUrls: ['./group-report-balance.component.css']
})
export class GroupReportBalanceComponent implements OnInit {
  private thisComponent: GroupReportBalanceComponent;
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  isEdit: boolean = false;

  // arrays
  book: any = null;
  bookings: any = [];
  concepts: any = [];
  expenses_operational: any = [];
  vehicle_private: any = constants.TOURISM.VEHICLE_TOURS[1].id;
  total_operational_group: any = 0;
  total_expense_operational: any = 0;
  conceptSelected: any = null;

  constructor(
    public fb: FormBuilder,
    private groupService: GroupService,
    private globalService: GlobalService,
    private routeActivated: ActivatedRoute,
    private router: Router,
    private alert: SwalAlert,
    private generalService: GeneralService,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.item = this.fb.group({
      id: [null],
      total_operational: [null],
      total_expense: [null]
    });
  }

  ngOnInit() {
    // this.navigationTrackerService.initializeMenu(this.routeActivated);
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    this.editData();
    this.getConceptExpenses();
  }

  editData(check_id = null) {
    this.groupService.detail(this.checkId).subscribe({
      next: (data: any) => {
        let result = data.data;
        this.book = result.book;
        this.bookings = result.bookings;
        for (let i in this.bookings) {
          this.bookings[i].total_operational =
            Number(this.bookings[i].price_corporate) *
            Number(this.bookings[i].quantity);
        }
        this.recalculateBalanceBooking();
        console.log(this.bookings);
      }
    });
  }

  getConceptExpenses() {
    this.generalService.listConceptExpenses().subscribe({
      next: (data: any) => {
        this.concepts = data.results;
        this.conceptSelected = this.concepts[0].id;
        console.log(this.conceptSelected);
      }
    });
  }

  changePriceCorporate(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      let total_operational_ = value_ * Number(this.bookings[index].quantity);
      this.bookings[index].price_corporate = value_;
      this.bookings[index].total_operational = total_operational_;
      this.recalculateBalanceBooking();
    }
  }

  recalculateBalanceBooking() {
    this.total_operational_group = 0;
    for (let i in this.bookings) {
      this.total_operational_group =
        this.total_operational_group + this.bookings[i].total_operational;
    }
  }

  addExpenseOperational() {
    let item_expense = this.toolsService.searchObjById(
      this.conceptSelected,
      this.concepts
    );
    if (
      this.toolsService.notExistObjInArr(
        item_expense,
        this.expenses_operational
      )
    ) {
      item_expense.quantity = 1;
      item_expense.price_operational = 0;
      item_expense.total_operational = 0;
      item_expense.observation = null;
      this.expenses_operational.push(item_expense);
      this.recalculateBalanceExpenseOperational();
    } else {
      this.alertifyMsg.warning(
        'El concepto ' + item_expense.description + ' ya se encuentra agregado'
      );
    }
  }

  changeExpenseOperationalQuantity(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      let total_operational_ =
        value_ * Number(this.expenses_operational[index].price_operational);
      this.expenses_operational[index].quantity = value_;
      this.expenses_operational[index].total_operational = total_operational_;
      this.recalculateBalanceExpenseOperational();
    }
  }

  changeExpenseOperationalPriceOperational(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      let total_operational_ =
        value_ * Number(this.expenses_operational[index].quantity);
      this.expenses_operational[index].price_operational = value_;
      this.expenses_operational[index].total_operational = total_operational_;
      this.recalculateBalanceExpenseOperational();
    }
  }

  changeExpenseOperationalObservation(param: any, index: number): void {
    let value_ = param.value;
    this.expenses_operational[index].observation = value_;
  }

  removeExpenseOperational(id: any, index: any) {
    this.expenses_operational.splice(index, 1);
    this.recalculateBalanceExpenseOperational();
  }

  recalculateBalanceExpenseOperational() {
    this.total_expense_operational = 0;
    for (let i in this.expenses_operational) {
      this.total_expense_operational =
        this.total_expense_operational +
        this.expenses_operational[i].total_operational;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    this.item.patchValue({
      id: this.checkId,
      total_operational: this.total_operational_group,
      total_expense: this.total_expense_operational
    });

    let data: any = {};
    if (this.validate()) {
      data.item = this.item.value;
      data.bookings = this.bookings;
      data.group_expenses = this.expenses_operational;
      // const formData = new FormData();
      // const headers = new HttpHeaders();
      // headers.append('Content-Type', 'multipart/form-data');
      // headers.append('Accept', 'application/json');
      // formData.append('item', JSON.stringify(data));
      // formData.append('expenses_operational', JSON.stringify(this.expenses_operational));
      console.log(data);

      if (this.isEdit) {
        // formData.append('id', JSON.stringify(this.checkId));
        // this.groupService.updateSave(formData).subscribe({
        //   next: (data: any) => {
        //     this.alertifyMsg.success('Registro actualizado con éxito');
        //     this.cancel();
        //   }
        // });
      } else {
        this.groupService.saveBalanceGroup(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (this.expenses_operational.length == 0) {
      this.alert.msgWarning(
        'Debe asignar al menos 1 item de gasto/egreso para poder registra el balance aproximado'
      );
      return false;
    }else{
      for(let i in this.expenses_operational){
        let item_ = this.expenses_operational[i];
        if (item_.quantity == 0 || _.isNull(item_.quantity)){
          this.alertifyMsg.warning("La cantidad para el item de gasto "+item_.description+" no pueder ser 0 o estar vacío");
          (<any>$('#expense_quantity'+i)).focus();
          return false;
        }

        if (item_.price_operational == 0 || _.isNull(item_.price_operational)){
          this.alertifyMsg.warning("El monto S/ para el item de gasto "+item_.description+" no pueder ser 0 o estar vacío");
          (<any>$('#expense_price_operational'+i)).focus();
          return false;
        }
      }
    }
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reportes/grupos']);
  }
}
